<template>
  <div class="emoji-picker">
    <el-popover
      placement="right"
      width="434"
      trigger="click"
    >
      <el-tabs
        v-model="emojiTabModel"
      >
        <el-tab-pane
          v-for="emojiTab in emojiTabs"
          :key="emojis[emojiTab].name"
          class="emoji-picker__tab-content"
        >
          <template slot="label">
            <font-awesome-icon
              :icon="emojis[emojiTab].icon"
              class="mx-1"
            />
          </template>

          <span
            v-for="(emoji, index) in emojis[emojiTab].list"
            :key="index"
            class="emoji-picker__icon px-1"
            @click="handleEmojiSelect(emoji)"
          >{{ emoji }}</span>
        </el-tab-pane>
      </el-tabs>

      <div class="pt-2">
        <a
          href="http://getemoji.com/"
          target="_blank"
          rel="noopener noreferrer"
        >Click here for more</a>
      </div>

      <template slot="reference">
        <slot
          :handleClick="handleTriggerClick"
          name="trigger"
        >
          <el-button
            class="emoji-picker__trigger-btn"
            circle
            @click="handleTriggerClick"
          >
            <font-awesome-icon
              :icon="['far', 'grin-alt']"
            />
          </el-button>
        </slot>
      </template>
    </el-popover>
  </div>
</template>

<script lang="ts">
import { createComponent, ref } from '@vue/composition-api'
import { emojis, emojiTabs } from '../../const/emojis'

const EmojiPicker = createComponent({
  setup(props, { emit }) {
    const isPickerOpen = ref(false)
    const handleTriggerClick = () => {
      isPickerOpen.value = true
    }

    const emojiTabModel = ref('0')
    const handleEmojiSelect = (emoji) => {
      emit('select', emoji)
    }

    return {
      // data
      isPickerOpen,
      emojis,
      emojiTabs,
      emojiTabModel,

      // handlers
      handleTriggerClick,
      handleEmojiSelect,
    }
  },
})

export default EmojiPicker
</script>

<style lang="scss" scoped>
$emoji-size: 28px;

.emoji-picker {
  &__trigger-btn {
    padding: 0;
    border: none;
    svg {
      font-size: 16px;
    }
  }

  &__tab-content {
    max-height: 376px;
    overflow-y: auto;

    span {
      font-family: Segoe UI Emoji;
      font-size: $emoji-size;
      cursor: pointer;
    }
  }
}
</style>
